import React, { useEffect } from "react";

import StyledChatBox from "./styles";
import TextContent from "./text-content";
import ImageContent from "./image-content";
import InfoContent from "./info-content";

const ChatBox = (props) => {
  const { color = "#dadada", vergulilla = true, inverted, type } = props;

  if (type === "info") {
    return (
      <StyledChatBox>
        <InfoContent {...props} />
      </StyledChatBox>
    );
  }

  return (
    <StyledChatBox>
      <div
        className={`chat-box-cont ${inverted ? "chat-box-cont--inverted" : ""}`}
      >
        <div className="chat-box">
          <div
            className={`background ${
              inverted ? "background--inverted" : "background--normal"
            }`}
            style={{ backgroundColor: color }}
          >
            {vergulilla && (
              <div className="vergulilla" style={{ backgroundColor: color }} />
            )}
          </div>

          {type === "text" && <TextContent {...props} />}
          {type === "image" && <ImageContent {...props} />}
        </div>
      </div>
    </StyledChatBox>
  );
};

export default ChatBox;
